<template>
  <div class="content">
    <!-- <div class="top">
      <span class="tit">云信护盾智能防窃电设备</span>
      <span
        >YXHD-M20智能防窃电设备是针对通信机房、户外林场、鱼塘、企业、工厂等领域安全用电控制需求而设计开发的一款高可靠性、实用性强的产品。</span
      >
      <span>
        与S20（从机）及各种传感器一起，组成一个完整的监控、主动防御系统。是整个系统的重要核心设备。
      </span>
    </div> -->
    <div class="swiper">
      <el-carousel height="760px">
        <el-carousel-item v-for="item in imgs" :key="item.url">
          <div class="top">
            <span class="tit">{{ item.text }}</span>
            <span>{{ item.text1 }}</span>
            <span>
              {{ item.text2 }}
            </span>
          </div>
          <div class="eve21">
            <img :src="item.url" />
            <button @click="showMore(item.num)">查看详情</button>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgs: [
        {
          url: require("../../assets/home-device/fqd.png"),
          num: 1,
          text: "云信护盾智能防窃电设备",
          text1:
            "智能防窃电系统是针对通信机房、户外林场、鱼塘、企业、工厂等领域安全用电控制需求而设计开发的一款高可靠性、实用性强的产品。",
          text2:
            "与S20（从机）及各种传感器一起，组成一个完整的监控、主动防御系统。是整个系统的重要核心设备。",
          path: "/production/fqd",
        },
        {
          url: require("../../assets/home-device/xdc.png"),
          num: 2,
          text: "BMS蓄电池智能监测系统",
          text1:
            "BMS蓄电池智能管理监测系统广泛应用于电力、通讯、地铁等行业，主要由前端YXBMS主机，配套电池组监控模YXBMS-A、",
          text2:
            "各种传感器和后台管理系统组成,可及时发现落后电池、续航时间预估、电池维护建议以及自动告警监督电池质量",
          path: "/production/BMS",
        },
        {
          url: require("../../assets/home-device/yccb.png"),
          num: 3,
          text: "智能远程抄表系统",
          text1:
            "可实时准确的进行电表度数远程抄收，远程智能采集终端设备将采集到的数据经过解析后通过4G传送至后台管理端，",
          text2: "前端数据实时刷新，支持报表统计、下载等功能，方便用户使用。",
          path: "/production/yccb",
        },
        {
          url: require("../../assets/home-device/EBM.png"),
          num: 3,
          text: "蓄电池单体检测模块（EBM）",
          text1:
            "蓄电池单体监测模块（EBM）可采集单体电池数据，进行电池故障诊断，实现电池统一管理。监测模块应用了多项发明专利技术，",
          text2: "具有监测电池的电压、内阻与温，度功能，安装、维护与接入及其方便，其主要性能远远高于同类厂家，处行业领先地位。",
          path: "/production/EBM",
        },
        // {
        //   url: require("../../assets/home-device/dcdu.png"),
        //   num: 3,
        //   text: "基站智能DCDU",
        //   text1:
        //     "智能DCDU用作基站开关电源电池连接端口与直流输出配电，可选母线输入/分路输出、每分路独立输入/输出两种结构，最大集成18路智能开关，并可按需级联，支持直流分路/分户（组）计量、差异化备电/发电管理、精准起租管理、免责时段管理、分路（小区）硬关断节能管理功能，支持分路开关容量自定义、分路与分组用户自定义功能，",
        //   text2: "支持分路电流突增异常告警功能，可选配4G无线数传组网（嵌入式FSU）功能。度功能，安装、维护与接入及其方便，其主要性能远远高于同类厂家，处行业领先地位。",
        //   path: "/production/EBM",
        // },
      ],
    };
  },
  methods: {
    showMore(num) {
      this.imgs.forEach((item) => {
        if (num == item.num) {
          this.$router.push(item.path);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 840px;
  //   border: 1px solid red;
  background: url(../../assets/bg.jpg) no-repeat 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .swiper {
    width: 1066px;
    // height: 554px;
    // border: 1px solid red;
    .top {
      display: flex;
      flex-direction: column;
      align-items: center;
      .tit {
        font-size: 40px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
        margin-top: 50px;
      }
      span {
        font-size: 16px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #666666;
        margin-top: 30px;
      }
    }
    .eve21 {
      width: 666px;
      height: 404px;
      // border: 1px solid red;
      margin: 50px auto;
      display: flex;
    flex-direction: column;
    align-items: center;
      img {
        width: 566px;
        height: 354px;
      }
      button {
        width: 175px;
        height: 44px;
        background: #f1bb2b;
        opacity: 1;
        outline: none;
        border: none;
        margin-top: 15px;
        font-size: 16px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
    }
    ::v-deep .el-carousel__arrow--left {
      // top: 70px;
      // left: -13px;
      font-size: 15px;
      // color: #02e9ff;
      background: #0b76e2;
    }
    ::v-deep .el-carousel__arrow--right {
      // top: 70px;
      // right: -13px;
      // font-size: 15px;
      background: #0b76e2;
    }
  }
}
</style>